import { useShallow } from 'zustand/react/shallow';
import useStageStore from '../stores/useStageStore';
import useDesignStore from '../stores/useDesignStore';
import useProductStore from '../stores/useProductStore';
import useUiStore from '../stores/useUiStore';
import usePropertiesStore from '../stores/usePropertiesStore';

export const useEditorStageState = () =>
  useStageStore(
    useShallow((s) => ({
      stage: s.stage,
      setStage: s.setStage,
      clipOutline: s.clipOutline,
      setClipOutline: s.setClipOutline,
      canvasSize: s.canvasSize,
      setCanvasSize: s.setCanvasSize,
      canvasPosition: s.canvasPosition,
      setCanvasPosition: s.setCanvasPosition,
      presetsDataSource: s.presetsDataSource,
      setPresetsDataSource: s.setPresetsDataSource,
      preset: s.preset,
      setPreset: s.setPreset,
      selectedElementPosition: s.selectedElementPosition,
      setSelectedElementPosition: s.setSelectedElementPosition,
    })),
  );

export const useEditorDesignState = () =>
  useDesignStore(
    useShallow((s) => ({
      design: s.design,
      setDesign: s.setDesign,
      designName: s.designName,
      setDesignName: s.setDesignName,
      userImages: s.userImages,
      setUserImages: s.setUserImages,
      ruleId: s.ruleId,
      setRuleId: s.setRuleId,
    })),
  );

export const useEditorProductState = () =>
  useProductStore(
    useShallow((s) => ({
      project: s.project,
      setProject: s.setProject,
      feedPage: s.feedPage,
      feedPageIndex: s.feedPageIndex,
      productIndex: s.productIndex,
      product: s.product,
      setProduct: s.setProduct,
      setProductFields: s.setProductFields,
      reloadingProducts: s.reloadingProducts,
      toPrevProduct: s.toPrevProduct,
      toNextProduct: s.toNextProduct,
    })),
  );

export const useEditorUiState = () =>
  useUiStore(
    useShallow((s) => ({
      isLayersPanelOpen: s.isLayersPanelOpen,
      isFontsPanelOpen: s.isFontsPanelOpen,
      isProductDataPanelOpen: s.isProductDataPanelOpen,
      isProductPropertiesOpen: s.isProductPropertiesOpen,
      toggleLayersPanel: s.toggleLayersPanel,
      toggleFontsPanel: s.toggleFontsPanel,
      toggleProductDataPanel: s.toggleProductDataPanel,
      toggleProductPropertiesPanel: s.toggleProductPropertiesPanel,
      setProductDataPanelOpen: s.setProductDataPanelOpen,
    })),
  );

export const useEditorPropertiesState = () =>
  usePropertiesStore(
    useShallow((s) => ({
      selectedGroup: s.selectedGroup,
      setSelectedGroup: s.setSelectedGroup,
      refreshProperties: s.refreshProperties,
    })),
  );
